import { Component, Input } from '@angular/core';

import { LoaderDiameter, LoaderSizeTypes } from '@app/eds';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  // Diameter of the spinner
  @Input() diameter!: LoaderSizeTypes;

  /**
   * Returns the size of the diameter based on passed props size.
   *
   * @return {string} sizeOfDiameter
   */
  getDiameter = () => {
    switch (this.diameter) {
      case LoaderSizeTypes.SMALL:
        return LoaderDiameter.LOADER_SM;
      case LoaderSizeTypes.MEDIUM:
        return LoaderDiameter.LOADER_MD;
      case LoaderSizeTypes.LARGE:
        return LoaderDiameter.LOADER_LG;
      default:
        return LoaderDiameter.LOADER_LG;
    }
  };
}
